import Super from "./class";
let serverList={
  get:{},
  post:{
    payPark: '/publics/storePayMethod/parkPay'    // 收银台支付停车场
  },
};
export default new Super(serverList,'park');
